//import React components
import PropTypes from "prop-types";
import {Button, Card, Container} from "reactstrap";
import {useRef, useState} from "react";
import {Link, useLocation} from "react-router-dom";

//import components

//import icons
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {fb_signOut} from "../../../../firebase/autentication/fb_signOut";
import {useAppState} from "../../../../context/state";
import {useCheckBrowserLocation} from "../../../../functions/Browser/Location/checkBrowserLocation";
import SideControl from "../../right/SideControl.js";
import {useDetectOutSideClick} from "../../../../functions/Triggers/eventListners.js";


//props settings for UserButton
UserButton.propTypes = {}

UserButton.defaultProps = {}

export default function UserButton() {
    const [open, setOpen] = useState(false);
    const sideControl = useRef(null);
    useDetectOutSideClick(sideControl, () => {
        setOpen(false);
    });
    return (
        <div ref={sideControl} className={"nav-dropdown-wrapper"}>
            <Button
                title={"Åpne bruker panel"}
                className={"nav-user"}
                color={"blank"}
                onClick={() => {
                    setOpen(!open);
                }}
            >
                <PersonOutlineIcon/>
            </Button>
            <SideControl state={[open, setOpen]}/>
        </div>
    )
}
